let ossConfigOption = {
    'guoranwisdom': {
        region: "oss-cn-zhangjiakou",
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: "y7bv+qK66l/o6j6BRe02wrhDi/COCv8ycac4XAkcs1M=",
        accessKeySecret: "VioIG83gV6Iv411IwO1jh1kUNIOnzKu63OEqJ0MJO+I=",
        // stsToken: '<Your securityToken(STS)>',
        bucket: "guoranwisdom",
    },
    'guoranopen-zjk': {
        region: "oss-cn-zhangjiakou",
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: "y7bv+qK66l/o6j6BRe02wrhDi/COCv8ycac4XAkcs1M=",
        accessKeySecret: "VioIG83gV6Iv411IwO1jh1kUNIOnzKu63OEqJ0MJO+I=",
        // stsToken: '<Your securityToken(STS)>',
        bucket: "guoranopen-zjk",
    },
    "askbotopen-ls": {
        region: "oss-ap-southeast-1",
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: "LTAI5tAusPLDNJJwkvUbqi2T",
        accessKeySecret: "xqPVaunOIbvTe3g9qsXal2IZO6RftK",
        // stsToken: '<Your securityToken(STS)>',
        bucket: "askbotopen-ls",
    },
    "askbotwisdom-ls": {
        region: "oss-ap-southeast-1",
        //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，创建并使用STS方式来进行API访问
        accessKeyId: "LTAI5tAusPLDNJJwkvUbqi2T",
        accessKeySecret: "xqPVaunOIbvTe3g9qsXal2IZO6RftK",
        // stsToken: '<Your securityToken(STS)>',
        bucket: "askbotwisdom-ls",
    }
};

function generateOssConfig(bucketType) {
    let config;
    if (process.env.VUE_APP_SOURCE === 'lishi') {
        if (bucketType === 'open') {
            config = ossConfigOption['askbotopen-ls']
        } else {
            config = ossConfigOption['askbotwisdom-ls']
        }
    } else if (process.env.VUE_APP_SOURCE === 'askbot' || process.env.VUE_APP_CONFIG_ENV !== 'production') {
        if (bucketType === 'open') {
            config = ossConfigOption['guoranopen-zjk']
        } else {
            config = ossConfigOption['guoranwisdom']
        }
    }
    return config;
}

export { generateOssConfig }


